import classNames from 'classnames'
import React from 'react'

import {SizeVariants} from '../../utils/constants'
import {CountryCode, countryMap} from './types'

export type FlagShape = 'square' | 'round' | 'rounded-square'
export interface FlagProps {
  countryCode: CountryCode;
  shape?: FlagShape;
  size?: SizeVariants;
  className?: string;
}
const Flag = ({countryCode: flag, shape = 'round', size = 'md', className}: FlagProps) => {
  const shapeClass = classNames({
    'rounded-sm': shape === 'rounded-square' && size === 'sm',
    'rounded-md': shape === 'rounded-square' && size === 'md',
    'rounded-lg': shape === 'rounded-square' && size === 'lg',
    'rounded-full': shape === 'round'
  })

  const sizeClass = classNames({
    'h-4': size === 'sm',
    'h-5': size === 'md',
    'h-6': size === 'lg',
    'w-4': shape === 'round' && size === 'sm',
    'w-5': shape === 'round' && size === 'md',
    'w-6': shape === 'round' && size === 'lg'
  })

  return (
    <div className={`overflow-hidden bg-kwota-primary/20 ${className} ${shapeClass} ${sizeClass}`}>
      <img
        loading="lazy"
        src={`https://flagcdn.com/h24/${flag.toLowerCase()}.webp`}
        className="object-cover h-full"
        alt={countryMap[flag]} />
    </div>
  )
}

export default Flag
